<script lang="ts">
    import About from "../components/About.svelte";
</script>

<main>
    <div class="top-container">
        <About />
    </div>
</main>
